import React, {Component} from 'react'
import {List,Toast} from 'antd-mobile'
import auth from '../../utils/auth'
import FarmLess from '../../components/farmLess'
import {ISDEMO} from '../../cache';

class SwineReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      showModal: true, // 是否 未合作
      reports: [
        {
          'title': '1.周性能概述表',
          'link': '/swine_report01'},
        {
          'title': '2.性能分析报表',
          'link': '/swine_report02'
        },
        {'title': '3.0胎母猪性能分析',
          'link': '/swine_report03'},
        {
          'title': '4.分娩分析',
          'link': '/swine_report04'
        },
        {
          'title': '5.分娩分析（未怀孕原因）',
          'link': '/swine_report05'
        },
        {
          'title': '6.重配天数分布图',
          'link': '/swine_report06'
        },
        {
          'title': '7.性能分析报表（按胎次分）',
          'link': '/swine_report07'
        },
        {
          'title': '8.技术人员生产数据统计表',
          'link': '/swine_report08'
        },
        {'title': '9.发情至第一次配种天数分布图',
          'link': '/swine_report09'
        },
        {
          'title': '11.淘汰母猪分析表',
          'link': '/swine_report11'
        },
        {
          'title': '12.淘汰母猪胎次分布图',
          'link': '/swine_report12'
        },
        {
          'title': '13.胎次结构分布图',
          'link': '/swine_report13'
        },
        {
          'title': '14.配种预警',
          'link': '/swine_report14'
        },
        {
          'title': '15.分娩预警',
          'link': '/swine_report15'
        },
        {
          'title': '16.断奶预警',
          'link': '/swine_report16'
        }],
      reports1: []
    }
  }
  async componentDidMount () {
    // Toast.info('mount 合作' + auth.getCookie('coop'), 2)
    // this.setState({
    //   showModal: auth.getCookie('coop') !== 'true'
    // })
  }
  clickLink = (item) => {
    let DEMO = ISDEMO;
    let cooperate = auth.getCookie('coop')==='true';
    // Toast.info('click link 合作' + auth.getCookie('coop') + auth.getCookie('farmorg') + auth.getCookie('orgcode'), 2);
    if (typeof android === 'undefined') {
      DEMO = auth.getCookie('farm_flag') === 'false';
    }
    if (!cooperate || DEMO) {
      // 没有合作
      this.setState({
        show: true
      });
    } else {
      this.props.history.replace(item.link)
    }
  };
  render() {
    const {show} = this.state;
    return (
      <React.Fragment>
        <div className="oneH">
          <List>
            {this.state.reports.map((item, index) => {
              return (
                <div
                    key={index}
                    onClick={this.clickLink.bind(this,item)}
                >
                  <List.Item arrow="horizontal"
                      key={index}
                  >
                    {item.title}
                  </List.Item>
                </div>
              )
            })}
          </List>
          <FarmLess {...this.props}
              show={show}
              onCancel={() => {
                      this.setState({
                        show: false
                      })
                    }}
          />
        </div>
      </React.Fragment>
    )
  }
}

export default SwineReport
